import { Interface, namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';

namespace('Ofcs.Editor.Context');

/**
 * @interface ContextInterface
 */
export default window.Ofcs.Editor.Context.ContextInterface = new Interface({
    /**
     * Return the item of the context
     */
    getItem() {},
    getName() {},
});
